import {useEffect} from 'react';

type ScriptConfig = {
  id: string;
  url: string;
};

export default function useScriptLoad(
  scriptConfigs: ScriptConfig[],
  delayMS?: number,
) {
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const addScripts = () => {
      const head = document.head;

      scriptConfigs.forEach(({id, url}) => {
        const script = document.createElement('script');
        script.id = id;
        script.type = 'text/javascript';
        script.src = url;
        script.async = true;

        const element = document.getElementById(id);

        // Remove script if it already exists
        if (element != null) {
          head.removeChild(element);
        }

        head.appendChild(script);
      });
    };

    if (delayMS != null) {
      timer = setTimeout(() => {
        addScripts();
      }, delayMS);
    } else {
      addScripts();
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [delayMS, scriptConfigs]);
}
